import { Component, OnInit, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { AppConstants } from 'src/app/classes/app/constants';
import { EImgIcons, EAppIcons, EAppIconsStandard } from 'src/app/classes/def/app/icons';
import { ETutorialEntries, Messages } from 'src/app/classes/def/app/messages';
import { ITutorial } from 'src/app/classes/def/app/tutorials';
import { EAlertButtonCodes } from 'src/app/classes/def/app/ui';
import { IBookingInfoContent } from 'src/app/classes/def/core/booking';
import { IEditorOpt, IEditorSettings } from 'src/app/classes/def/core/editor';
import { ErrorMessage } from 'src/app/classes/general/error-message';
import { TimeUtils } from 'src/app/classes/general/time';
import { IUnlockContentCheckoutParams, UnlockContentCheckoutComponent, IUnlockContentCheckoutReturnData } from 'src/app/modals/app/modals/unlock-content-checkout/unlock-content-checkout.component';
import { MarketplaceDataService } from 'src/app/services/data/marketplace';
import { ResourcesCoreDataService } from 'src/app/services/data/resources-core';
import { UiExtensionService } from 'src/app/services/general/ui/ui-extension';
import i18next from 'i18next';

export enum EBookingCheckAction {
  showInfo = 1,
  openStoryPage = 2
}

export interface IBookingCheckReturn {
  action: number;
  data: IBookingInfoContent;
}

@Component({
  selector: 'booking-check',
  templateUrl: './booking-check.component.html',
  styleUrls: ['./booking-check.component.scss'],
})
export class BookingCheckComponent implements OnInit, OnDestroy {
  imgIcons = EImgIcons;
  icons = EAppIcons;
  appIconsStandard = EAppIconsStandard;

  bookingProvider: number = null;
  bookingProviderOTAs: IEditorOpt[] = null;

  bookingReferenceInfo: string = "";
  bookingReferenceInfoIcon: string = null;

  bookingReference: string = "";
  bookingPrefix: string = "";

  bookingCustomerName: string = "";

  @Input()
  settings: IEditorSettings;

  @Input()
  isBookingCode: boolean;

  @Output()
  action: EventEmitter<any> = new EventEmitter();

  constructor(
    private resourcesProvider: ResourcesCoreDataService,
    private uiext: UiExtensionService,
    private marketplaceDataService: MarketplaceDataService
  ) {

  }

  ngOnInit() {
    this.bookingProviderOTAs = [{
      name: "Any",
      value: null,
      description: null
    } as IEditorOpt].concat(this.settings.bookingOTAs.filter(ota => ota.description != null)); // keep only options with prefix
  }

  selectProvider() {
    console.log("select provider: ", this.bookingProvider);
    let opt: IEditorOpt = this.bookingProviderOTAs.find(bp => bp.value === this.bookingProvider);
    console.log("provider: ", opt);
    let prefix: string = opt?.description;
    this.bookingPrefix = prefix;
  }

  async switchLoadBookingCode() {
    if (!this.isBookingCode) {
      await this.loadBookingCodeInfo();
      this.isBookingCode = true;
    } else {
      this.loadBookingCodeInfo();
    }
  }

  async loadBookingCodeInfo() {
    try {
      await this.uiext.showLoadingV2Queue("Loading..");
      let tutorial: ITutorial = await this.resourcesProvider.getInfoData(ETutorialEntries.bookingCodeNote, true);
      let description: string = tutorial.description;
      this.bookingReferenceInfo = description;
      this.bookingReferenceInfoIcon = tutorial.photoUrl;

      // let params: IUnlockContentCheckoutParams = {
      //     title: tutorial.title,
      //     description: description,
      //     descriptionFooter: null,
      //     iconDescription: tutorial.photoUrl,
      //     iconFooter: tutorial.photoUrlIos,
      //     unlockCodes: null
      // };
      // this.uiext.showCustomModal(null, UnlockContentCheckoutComponent, {
      //     view: {
      //         fullScreen: false,
      //         transparent: AppConstants.transparentMenus,
      //         large: true,
      //         addToStack: true,
      //         frame: false
      //     },
      //     params: params
      // }).then((res: number) => {
      //     console.log(res);
      // }).catch((err: Error) => {
      //     console.error(err);
      // });
      await this.uiext.dismissLoadingV2();
    } catch (err) {
      console.error(err);
      await this.uiext.dismissLoadingV2();
    };
  }

  loadBookingInstructionsForReference() {
    if (!(this.bookingReference || this.bookingCustomerName)) {
      this.uiext.showAlertNoAction(Messages.msg.bookingReferenceMissing.after.msg, Messages.msg.bookingReferenceMissing.after.sub);
      return;
    }
    let bookingReference: string = this.bookingReference;
    // parse booking reference
    if (this.bookingPrefix != null) {
      // check existing prefix
      if (bookingReference.indexOf(this.bookingPrefix) !== -1) {
        // ok
        this.bookingReference = this.bookingReference.replace(this.bookingPrefix, "");
      } else {
        bookingReference = this.bookingPrefix + bookingReference;
      }
    }

    // check provider match (if not selected)
    // if (this.bookingProvider == null) {
    //     for (let bp of this.bookingProviderOTAs) {
    //         if (bp.description != null && bookingReference.indexOf(bp.description) !== -1) {
    //             this.bookingProvider = bp.value;
    //             this.bookingReference = this.bookingReference.replace(bp.description, "");
    //             break;
    //         }
    //     }
    // }

    this.marketplaceDataService.getBookingMessage(bookingReference, this.bookingProvider, this.bookingCustomerName, null).then((bic: IBookingInfoContent) => {
      let params: IUnlockContentCheckoutParams = {
        title: "Booking notes",
        description: bic.description,
        descriptionFooter: null,
        iconDescription: null,
        iconFooter: null,
        unlockCodes: bic.unlockCodes,
        continueBtnText: i18next.t("ui:actions.proceed") as string
      };
      this.uiext.showCustomModal(null, UnlockContentCheckoutComponent, {
        view: {
          fullScreen: false,
          transparent: AppConstants.transparentMenus,
          large: true,
          addToStack: true,
          frame: false
        },
        params: params
      }).then((res: IUnlockContentCheckoutReturnData) => {
        console.log(res);
        if (res != null) {
          if (res.actionCode === EAlertButtonCodes.ok) {
            let emitData: IBookingCheckReturn = {
              action: EBookingCheckAction.openStoryPage,
              data: bic
            };
            this.action.emit(emitData);
          }
        }
      }).catch((err: Error) => {
        console.error(err);
      });
    }).catch((err) => {
      console.error(err);
      this.uiext.showAlertNoAction(Messages.msg.requestFailed.after.msg, ErrorMessage.parse(err, Messages.msg.requestFailed.after.sub));
    });
  }

  ngOnDestroy() {

  }

}
